// extracted by mini-css-extract-plugin
module.exports = {"Onboardingpage":"Onboarding_Onboardingpage__7SlMR"};